import { Checkbox, CheckboxControl, CheckboxIndicator } from "@heroui/react";
import { MealSlot } from "../api/client";
import { SLOT_ROWS } from "../constants";

interface Props {
  value: MealSlot[] | undefined;
  onChange: (next: MealSlot[]) => void;
}

export function SlotDefaultsEditor({ value, onChange }: Props) {
  const safeValue = Array.isArray(value) ? value : [];
  const selected = new Set(safeValue);

  function toggle(slot: MealSlot) {
    const next = selected.has(slot)
      ? safeValue.filter((item) => item !== slot)
      : [...safeValue, slot];

    onChange(next);
  }

  return (
    <div className="space-y-3 rounded-2xl border border-default-200 bg-surface p-4 shadow-sm">
      <div className="space-y-1">
        <div className="text-sm font-semibold text-foreground">Actiu per defecte</div>
        <div className="text-xs leading-relaxed text-muted">
          Marca quines franges han d&apos;entrar automàticament quan arrosseguis una recepta.
        </div>
      </div>

      <div className="grid gap-2 sm:grid-cols-2">
        {SLOT_ROWS.map((row) => (
          <Checkbox
            key={row.slot}
            isSelected={selected.has(row.slot)}
            onChange={() => toggle(row.slot)}
            className="w-full items-center gap-3 rounded-xl border border-default-200 bg-surface-secondary px-3 py-2 transition-colors hover:border-primary/40 hover:bg-default-100"
          >
            <CheckboxControl className="inline-flex h-5 w-5 shrink-0 items-center justify-center rounded border border-default-300 bg-surface text-primary">
              <CheckboxIndicator className="h-4 w-4" />
            </CheckboxControl>
            <span className="text-sm font-medium text-foreground">{row.label}</span>
          </Checkbox>
        ))}
      </div>
    </div>
  );
}
